import Vue from 'vue'
import i18n from '@/languages'
import app from '@/main'

const editRecommendationModule = {
  namespaced: true,
  state: {
    currentServiceName: null
  },

  mutations: {
    setCurrentServiceName: (state, name) => (state.currentServiceName = name)
  },

  getters: {
    getRulesForService: (state, getters, rootState) => {
      const currentService = rootState
        .recommendations
        .listProductRecommendation
        .services.business_rules_config[state.currentServiceName]

      const result = []

      Object.keys(currentService).forEach(el => {
        if (Array.isArray(currentService[el])) {
          let category
          const items = currentService[el].map(item => ({...item, active: false}))

          if (el === 'offer_to_offer') {
            category = 1
          }

          if (el === 'offer_to_category') {
            category = 2
          }

          if (el === 'category_to_category') {
            category = 3
          }

          result.push({category, items, active: false})
        }
      })

      return result
    },
    getAllRules: (state, getters, rootState, rootGetters) => {
      const rules = rootGetters['recommendations/listBusinessRules/getBusinessRules']

      return rules.map(el => {
        let category

        if (el.rule_type.toLowerCase() === 'offer_to_offer') {
          category = 1
        }

        if (el.rule_type.toLowerCase() === 'offer_to_category') {
          category = 2
        }

        if (el.rule_type.toLowerCase() === 'category_to_category') {
          category = 3
        }

        return {...el, category}
      })
    },

    getCurrentServicesDetails: (state, getters, rootState) => {
      const currentService = rootState
        .recommendations
        .listProductRecommendation
        .services.services_details
        .filter(service => service.name === state.currentServiceName)[0]

      return currentService
    }
  },

  actions: {
    UPDATE_RECOMMENDATION: async ({dispatch, commit, rootGetters}, body) => {
      try {
        const response = await Vue.http.patch(`${rootGetters.getBackendUrl}/recommendations`, body, {
          headers: rootGetters.getAllResponseHeaders
        })

        if (response.body.result.status && response.body.result.status === 'success') {
          await dispatch('recommendations/listProductRecommendation/GET_ALL_SERVICES', null, {root: true})
          app.$message('success', i18n.t('instruments.recommendation.recommendation_updated'))
        }
      } catch (e) {
        app.$message('danger', e.statusText || 'Error')
        app.$raven.captureException(e)
      }
    }
  }
}

export default editRecommendationModule



// WEBPACK FOOTER //
// ./src/store/modules/recommendations/modules/edit_recommendation.js